import NextLink from 'next/link';
import { Arrow } from '../SVGs';

interface LinksElementProps {
  href: string;
  linkText: string;
}

const BlankLink: React.FC<LinksElementProps> = ({ href, linkText }) => {
  const isExternal = isExternalUrl(href);
  const Element = isExternal ? ExternalLink : NextLink;

  const words = linkText.trim().split(' ');
  const lastWord = words.pop();
  const rest = words.join(' ');

  return (
    <Element href={href} className="text-2xl tablet:text-3xl">
      {rest && <>{rest} </>}
      <span className="inline-flex items-center whitespace-nowrap">
        {lastWord}
        <Arrow
          color="currentColor"
          className={`h-[1em] w-[1em] ml-8 ${isExternal ? '-rotate-45' : ''}`}
        />
      </span>
    </Element>
  );
};

export default BlankLink;

const isExternalUrl = (url: string): boolean => {
  return /^https?:\/\//.test(url);
};

const ExternalLink: React.FC<{
  children: React.ReactNode;
  className: string;
  href: string;
}> = ({ children, href, className }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
};
